import { render, staticRenderFns } from "./activityFlowForm.vue?vue&type=template&id=11c63421&scoped=true&"
import script from "./activityFlowForm.vue?vue&type=script&lang=js&"
export * from "./activityFlowForm.vue?vue&type=script&lang=js&"
import style0 from "./activityFlowForm.vue?vue&type=style&index=0&id=11c63421&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c63421",
  null
  
)

export default component.exports